import {
  CHEESEBURGER_CALORIES,
  drinkUnitAndCalories
} from "@dcc/constants/drinkConstants";
import { Drinks } from "@dcc/types/drinks";

export const getCaloriesAsBurgers = (totalWeeklyCalories: number) =>
  totalWeeklyCalories / CHEESEBURGER_CALORIES;

export const getUnitsAsSpirits = (totalWeeklyUnits: number) =>
  totalWeeklyUnits / drinkUnitAndCalories[Drinks.spirit].units;

export const getUnitsAsBeers = (totalWeeklyUnits: number) =>
  totalWeeklyUnits / drinkUnitAndCalories[Drinks.beer].units;
